import { UnplugIcon } from "lucide-react";
import "./McpServerTile.scss";
import { useNavigate } from "react-router-dom";
import { linkToMcpServer } from "../../../routes";
import Message from "../../../i18n/Message";

/**
 * Statuses worth calling out on a tile. A ready playground says nothing — it speaks through its
 * description — but one that is still being built has no description to show, and used to be
 * indistinguishable from a finished one.
 *
 * CREATED is the plain create path mid-analysis (it only leaves that status when it finishes);
 * ANALYZING is the OAuth and re-inspection path.
 */
const TILE_STATUS = {
  CREATED: { dot: "yellow", messageId: "mcp_server_status_analizing" },
  ANALYZING: { dot: "yellow", messageId: "mcp_server_status_analizing" },
  PENDING_AUTH: { dot: "yellow", messageId: "mcp_server_status_pending_auth" },
  ERROR: { dot: "red", messageId: "mcp_server_status_error" },
};

const McpServerTile = ({ playground }) => {
  const nav = useNavigate();
  const status = TILE_STATUS[playground.status];
  return (
    <div
      className="mcp_server_tile"
      onClick={() => nav(linkToMcpServer(playground.uid))}
    >
      <div className="title_row">
        <div className="icon_container">
          <div className="icon_circle">
            <UnplugIcon size={24} color="#67748e" />
          </div>
        </div>
        <div className="title_column">
          <div className="title_value">{playground.name}</div>
          <div className="slug_container">
            <div className="slug" title={playground.websiteUrl}>
              {playground.websiteUrl}
            </div>
          </div>
        </div>
      </div>
      {status && (
        <div className="tile_status">
          <div className={"status_icon " + status.dot}></div>
          <Message id={status.messageId} />
        </div>
      )}
      <div className="description_container">
        <div className="description">{playground.description}</div>
      </div>
    </div>
  );
};

export default McpServerTile;
